import { render } from "./NewClaimYearSelector.vue?vue&type=template&id=137e07fa&scoped=true&ts=true"
import script from "./NewClaimYearSelector.vue?vue&type=script&lang=ts"
export * from "./NewClaimYearSelector.vue?vue&type=script&lang=ts"

import "./NewClaimYearSelector.vue?vue&type=style&index=0&id=137e07fa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.9.3__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137e07fa"]])

export default __exports__